// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ee","content":"ef","header":"eh","message":"ei","iframeWrapper":"ej"};